<div class="role-form">
    <h2>{{ employeeTypeId ? 'Edit' : 'Add' }} Employee Type </h2>

    <form [formGroup]="employeeTypeForm" (ngSubmit)="onSubmit()">

        <div class="custom-form-group">
            <label class="custom-label" for="">Employee Type
                <span class="star" style="display: inline-block !important;">*</span>
            </label>
            <div class="custom-form-control">
                <mat-form-field appearance="outline">
                    <input matInput placeholder="Employee Type" formControlName="employee_type_name">
                    <mat-error *ngIf="employeeTypeForm.controls['employee_type_name'].invalid && employeeTypeForm.controls['employee_type_name'].touched">
                        Employee Type is required
                    </mat-error>
                </mat-form-field>
            </div>
        </div>

        <div class="button-group" style="display: flex; justify-content: space-between; align-items: center;" fxLayoutAlign="end end" style="margin-top:auto;">
            <button mat-button type="button" color="warn" (click)="onCancel()">Cancel</button>

            <div fxLayout="row" fxLayoutAlign="end end" fxLayoutGap="15px">
                <button type="submit" mat-button class="global-btn btn btn-sm">{{ employeeTypeId ? 'Update' : 'Add' }}</button>
            </div>
        </div>

    </form>
</div>